import {FC} from "react";
import {useTranslation} from "react-i18next";

export const Footer: FC = () => {
	const {t} = useTranslation();
	const year = new Date().getFullYear();

	return (
		<footer className="footer">
			<div className="container">
				<div className="row g-4">
					<div className="col-12 col-md-4 pb-2">
						<img
							className="footer__logo"
							src="/images/logo.svg"
							alt={t("siteName")}
							height={52}
						/>
						<p className="footer__tagline">{t("footer.tagline")}</p>
					</div>
					<div className="col-6 col-md-3 offset-md-1">
						<h5 className="footer__heading">{t("footer.menuTitle")}</h5>
						<ul className="menu menu--footer">
							<li className="menu__item"><a href="#features">{t("header.features")}</a></li>
							<li className="menu__item"><a href="#how-it-works">{t("header.howItWorks")}</a></li>
							{/* <li className="menu__item"><a href="#pricing">{t("header.pricing")}</a></li> Pricing temporarily hidden */}
							<li className="menu__item"><a href="#faq">{t("header.faq")}</a></li>
						</ul>
					</div>
					<div className="col-6 col-md-4">
						<h5 className="footer__heading">{t("footer.contactsTitle")}</h5>
						<ul className="menu menu--footer">
							<li className="menu__item"><a href="tel:722005017">722 005 017</a></li>
							<li className="menu__item"><a href="mailto:jiri.tichy@apesight.com">jiri.tichy@apesight.com</a></li>
						</ul>
					</div>
				</div>
				<p className="footer__copyright">
					{t("footer.copyright", {year})}
				</p>
			</div>
		</footer>
	);
};
